import { Button as MuiButton } from '@mui/material';
import styled from 'styled-components';
import Icon from '../Icon';
export const ButtonStyled = styled(MuiButton).attrs({
    disableRipple: true,
})(({ theme, variant = 'primary', }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return ({
        borderRadius: '100px',
        border: '1px solid',
        display: 'flex',
        minWidth: '50px',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 24px',
        ...{
            primary: {
                background: (_a = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _a === void 0 ? void 0 : _a.black,
                borderColor: (_b = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _b === void 0 ? void 0 : _b.black,
                color: (_c = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _c === void 0 ? void 0 : _c.white,
                ':hover': {
                    background: (_d = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _d === void 0 ? void 0 : _d[600],
                    borderColor: (_e = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _e === void 0 ? void 0 : _e[600],
                },
                ':disabled': {
                    background: (_f = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _f === void 0 ? void 0 : _f[300],
                    borderColor: (_g = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _g === void 0 ? void 0 : _g[300],
                    color: (_h = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _h === void 0 ? void 0 : _h[600],
                },
            },
            secondary: {
                background: (_j = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _j === void 0 ? void 0 : _j.white,
                borderColor: (_k = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _k === void 0 ? void 0 : _k.black,
                color: (_l = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _l === void 0 ? void 0 : _l.black,
                ':hover': {
                    background: (_m = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _m === void 0 ? void 0 : _m[600],
                    borderColor: (_o = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _o === void 0 ? void 0 : _o[600],
                    color: (_p = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _p === void 0 ? void 0 : _p.white,
                },
                ':disabled': {
                    background: (_q = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _q === void 0 ? void 0 : _q[300],
                    borderColor: (_r = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _r === void 0 ? void 0 : _r[300],
                    color: (_s = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _s === void 0 ? void 0 : _s[600],
                },
            },
            text: {
                background: 'transparent',
                borderColor: 'transparent',
                textDecoration: 'underline',
                color: (_t = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _t === void 0 ? void 0 : _t.black,
                ':hover': {
                    color: (_u = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _u === void 0 ? void 0 : _u[600],
                    background: 'transparent',
                },
                ':disabled': {
                    color: (_v = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _v === void 0 ? void 0 : _v[500],
                },
            },
        }[variant],
    });
});
export const ButtonIcon = styled(Icon).attrs(({ color, }) => ({
    size: 's',
}))(({ theme, }) => {
    return ({
        svg: {},
    });
});
//# sourceMappingURL=Button.styles.js.map